export enum StatsApiMethods {
    getStats = 'Stats.GetOrdersStats',
    getRevenueStatsByMenuCategoryId = "Stats.GetRevenueStatsByMenuCategoryId",
    getRevenueStatsByMenuItemId = "Stats.GetRevenueStatsByMenuItemId",
    getTimeSeriesStats = "Stats.GetTimeSeriesStats",
}
